import { render } from "./SmartFormComplete.vue?vue&type=template&id=e5c4399c&ts=true"
import script from "./SmartFormComplete.vue?vue&type=script&lang=ts"
export * from "./SmartFormComplete.vue?vue&type=script&lang=ts"

import exportComponent from "/buddy/uup/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__